import Box from '@mui/material/Box';

/**
 * A marca, em dois recortes.
 *
 * A arte é azul sobre branco e não tem versão para fundo escuro, então ela vai
 * sempre dentro de um retângulo branco: no tema escuro, posta direto sobre o
 * fundo, as letras somem.
 *
 * `marca` é só o monograma — a assinatura completa, reduzida a 32 px de altura
 * na barra lateral, vira um borrão ilegível.
 */
export function Logo({
  variante = 'completa',
  altura = 40,
}: {
  variante?: 'completa' | 'marca';
  altura?: number;
}) {
  return (
    <Box
      component="img"
      src={variante === 'marca' ? '/logo-rk.png' : '/logo.png'}
      alt="RK Solutions"
      sx={{
        height: altura,
        width: 'auto',
        display: 'block',
        bgcolor: '#fff',
        borderRadius: 1.5,
        p: 0.5,
      }}
    />
  );
}
